export default __webpack_public_path__ + "static/media/evoko_logo.25fab3a9.png";